import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertMessagesConfig } from 'config/alert-messages.config';
import { environment } from 'environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';

export interface AchPaymentRequest {
  sysId?: string;
  caseSysId?: string;
  orderId?: string;
  achAccountType: string;
  achAccountNumber: string;
	achRoutingNumber: string;
	firstName: string;
  lastName: string | undefined;
	street1: string;
  street2: string;
  city: string;
  state: string;
  postalCode: string;
  company?:string;
  amount:string | undefined;
  formType? : string
  formEApplicationType? : string
}



@Injectable({
  providedIn: 'root'
})
export class PaymentService {
 
  constructor(
    private http: HttpClient,
    public alertsMessageConfig: AlertMessagesConfig,
  ) { }

  public processAchTransaction(req: AchPaymentRequest): Observable<any> {
      return this.http.post<any>('usanapi/processAch', req)
       .pipe(
          map(response => {
            console.log (`response ${JSON.stringify(response)}`)
            return response;
          }),
          catchError(() => {
            return throwError(() => new Error(this.alertsMessageConfig.defaultServerError));
          }));
  }
}
